import React from 'react'
import PropTypes from 'prop-types'
import FormElement from './FormElement'
import TextareaAutosize from 'react-textarea-autosize'

const TextArea = ({
    inlineDescription,
    maxLength,
    autoSize,
    rows,
    minRows,
    maxRows,
    placeholder,
    ...props
}) => {
    const { form, field } = props
    const { name, value } = field
    const { touched, errors } = form
    const error = touched[name] && errors[name]

    const TextAreaComponent = autoSize ? TextareaAutosize : 'textarea'

    const autoSizeProps = autoSize ? {
        minRows,
        maxRows,
    } : {
        rows,
    }

    return (
        <FormElement
            name={name}
            value={value}
            error={error}
            inlineDescription={inlineDescription}
            {...props}
        >
            {({ field }) => {
                return React.createElement(TextAreaComponent, {
                    type: 'text',
                    maxLength: maxLength,
                    placeholder: placeholder,
                    ...field,
                    ...autoSizeProps,
                })
            }}
        </FormElement>
    )
}

PropTypes.propTypes = {
    minRows: 2,
    maxRows: 15,
    placeholder: PropTypes.string,
}

PropTypes.defaultValues = {
    rows: 7,
    maxLength: 5000,
}

export default TextArea
